import { Component, h, State, Prop, Event, EventEmitter, Watch } from '@stencil/core';
import AuthHeader from "../auth-header";
import { updateFieldValidations } from '../utils';
import { requestResetPassword } from '../../../components/hd-auth/requests';
import { i18n } from '../../../utils/i18n';

@Component({
  tag: 'hd-recover',
  shadow: false
})
export class HdRecover {
  @Prop({ mutable: true }) type: "signup" | "recover" | "check-inbox" = "recover";
  @Prop({ mutable: true }) email: string = '';
  @Prop() url: string;

  @Event() nextStep: EventEmitter<Record<string, string | boolean>>;
  @Event() recoverStep: EventEmitter<Record<string, string | boolean>>;

  @State() loading = false;
  @State() isFormValid = false;
  @State() errorFormFields: Record<string, boolean | null> = {
    email: null
  };

  t = i18n.get("hd-auth");

  private validationTimeouts: Record<string, number> = {};

  @Watch("type")
  typeChanged() {
    this.recoverStep.emit();
  }

  updateField(field: string, e: Event) {
    const target = e.target as HTMLInputElement;
    this[field] = target.value;

    if (this.validationTimeouts[field]) {
      clearTimeout(this.validationTimeouts[field]);
    }

    this.validationTimeouts[field] = window.setTimeout(() => {
      this.validateField(field, target);
    }, 500);
  }

  validateField = (field: string, target: HTMLInputElement) => {
    const isValid = updateFieldValidations(field, target);
    this.errorFormFields[field] = isValid;
    this.isFormValid = Object.values(this.errorFormFields).every(isValid => isValid === true);
  }

  handleError = (error: any, target: HTMLInputElement) => {
    const parentGroup = target.parentElement.parentElement;
    const errorElement = parentGroup.querySelector(".error-message");

    if (!parentGroup || !errorElement) {
      return;
    }

    parentGroup.classList.toggle("has-error", !!error);
    errorElement.textContent = error.status === 400 ? error.message : this.t('error.unprocessed_request');
    this.loading = false;
    this.errorFormFields.email = false;
  }

  submit = async (target: HTMLInputElement) => {
    try {
      this.loading = true;
      const res = await requestResetPassword(this.url, this.email);

      if (!res) {
        this.handleError({ message: "No response from server", status: 500 }, target);
        return;
      }

      this.loading = false;
      this.nextStep.emit({ type: this.type, email: this.email });
    } catch (error) {
      this.handleError(error, target);
    }
  }

  render() {
    return (<form class="form-container step-container recover">
      <AuthHeader
        title={this.t('recover.title')}
        subhead={this.t('recover.subtitle')}
      />
      <div class="form-body">
        <div class="form-group">
          <label htmlFor="email">{this.t('recover.email')}</label>
          <input type="email" id="email"
            value={this.email}
            onInput={(e) => this.updateField("email", e)}
            onBlur={(e) => this.validateField("email", e.target as HTMLInputElement)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                e.stopPropagation();

                this.isFormValid && this.submit(e.target as HTMLInputElement);
              }
            }}
          />
          <p class="error-message"></p>
        </div>
      </div>
      <div class="step-actions">
        <hd-button primary padded
          disabled={!this.isFormValid || this.loading}
          onClick={(e) => this.submit(e.target as HTMLInputElement)}>
          {this.loading ? <hd-icon svg="loader_bouncing_circles" width="24" height="24" /> : this.t('recover.button')}
        </hd-button>
        <p class="login-link">{this.t('recover.signup_question')} <span onClick={() => this.type = "signup"}>{this.t('recover.signup_link')}</span></p>
      </div>
    </form>
    )
  }
}